import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY, MEDIA, waLink } from "@/lib/constants";

const NAV = [
  { label: "Início", href: "#home" },
  { label: "Serviços", href: "#servicos" },
  { label: "Pesados", href: "#pesados" },
  { label: "Sobre", href: "#sobre" },
  { label: "Área", href: "#area" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Redes", href: "#redes" },
  { label: "Contato", href: "#contato" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 w-full z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10"
          : "bg-gradient-to-b from-[#0a0a0a]/80 to-transparent"
      }`}
    >
      <div className="container-custom flex items-center justify-between h-20 md:h-24">
        <a
          href="#home"
          data-testid="header-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={MEDIA.logo}
            alt="Auto Socorro Ventania Ribeirão Preto"
            className="h-14 md:h-16 w-14 md:w-16 object-contain"
          />
          <div className="hidden sm:block">
            <div className="font-display uppercase font-bold text-white text-base leading-none tracking-tight">
              Auto Socorro
            </div>
            <div className="font-display uppercase font-bold text-[#d90429] text-xl leading-none tracking-tight">
              Ventania
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((it) => (
            <a
              key={it.href}
              href={it.href}
              data-testid={`nav-${it.href.replace("#", "")}`}
              className="font-display uppercase tracking-widest text-sm text-white/80 hover:text-[#d90429] transition-colors"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneTel}`}
            data-testid="header-phone-cta"
            className="hidden md:inline-flex items-center gap-2 text-white hover:text-[#d90429] font-display uppercase tracking-wider text-sm border-l border-white/10 pl-4"
          >
            <Phone className="w-4 h-4 text-[#d90429]" />
            <span>{COMPANY.phoneDisplay}</span>
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden sm:inline-flex btn-wa text-xs md:text-sm px-5 py-3"
          >
            <i className="fa-brands fa-whatsapp text-lg" aria-hidden></i>
            WhatsApp
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            aria-label="Abrir menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#0a0a0a] border-t border-white/10"
        >
          <div className="container-custom py-6 flex flex-col gap-4">
            {NAV.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="font-display uppercase tracking-wider text-white/85 hover:text-[#d90429] py-2"
              >
                {it.label}
              </a>
            ))}
            <a
              href={`tel:${COMPANY.phoneTel}`}
              className="flex items-center gap-2 text-white font-display uppercase tracking-wider pt-4 border-t border-white/10"
            >
              <Phone className="w-4 h-4 text-[#d90429]" />
              {COMPANY.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
